<sc-action-icon [disabled]="disabled" (click)="clickButton()"
  title="{{'attach / detach' | translate:['tmc-yard.ui.control.sac-client.station-transport-details.action.call', translationService.language, translationService.revision]}}"
  iconClass="fa-envelope-square">
</sc-action-icon>
